/**
 * /devhub/scheduler — Phase 10 AgentScheduler surface.
 * REQ-001.91 DevHub UI rebuild · Phase 10 (autonomous agent runtime).
 *
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 * Mounts `DevHubSchedulerPanel` inside the standard DevHub panel chrome.
 */

import { createFileRoute } from '@tanstack/react-router';
import { DevHubSchedulerPanel } from '../features/control-plane/DevHubSchedulerPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/scheduler')({
  component: SchedulerPage,
});

function SchedulerPage() {
  return (
    <DevHubPanelPage
      title="Agent Scheduler"
      subtitle="Phase 10 — autonomous agent runtime. 5 default scheduled tasks (health probe, RAG freshness, local inference canary, eval gate, version freshness). All opt-in; the master switch + per-task arming flags live in Config/parameters/parameters.registry.json."
      status={{ state: 'polling', label: 'opt-in', detail: 'Phase 10' }}
    >
      <DevHubSchedulerPanel />
    </DevHubPanelPage>
  );
}
